import { render, staticRenderFns } from "./InvoiceDetailsCard.vue?vue&type=template&id=32aba9df"
import script from "./InvoiceDetailsCard.vue?vue&type=script&lang=ts"
export * from "./InvoiceDetailsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports